<app-mainscreen>
    <app-simple-page-heading [breadcrumbs]="['Dashboard > Sales']" title="Sales" ></app-simple-page-heading>
    <div class="box_container mt-4 pt-2 rounded-bottom1-0 position-relative justify-content-start overflow-initial">
      
      <div class="row w-100 position-relative">
        <div class="col-12 mb-4">
          <div class="row justify-content-end align-items-center">
            <div class="col-auto d-flex align-items-center d-none">Policy Start Month & Year</div>
            <div class="col-auto d-none">              
              <app-month-year-picker (valueChange)="monthYearChange($event)" [value]="selectedMonthYear" [maxDate]="maxMonthYear"></app-month-year-picker>
            </div>
            <div class="col-auto">
              <app-date-range-picker [selectedStartDate]="this.selectedStartDate" [selectedEndDate]="this.selectedEndDate"  [selectedDateRange]="this.selectedDateRange" (dateRangeChange)="onDateRangeChange($event)" [id]="'dateRangePicker_'"></app-date-range-picker>
            </div>
          </div>
        </div>  
        <div class="col-12">
          <div class="row">
            <div class="col-md-2 position-relative h-30 mb-4">
              <app-multi-dropdown class="w-100 multiselect_custom input_ d-block" [items]="insurancePartnersList"
                  [className]="'bg-white'" [showSearch]="true" [showAll]="true" [showStatus]="false" [ddlMenuClassName]="'w-auto'"
                  (itemChange)="onInsuranceCompanyMultiSelectChange($event)" placeholder=" " id="insuranceCompanyFilter">
              </app-multi-dropdown>
              <label class="float-start label_ms fs-14-br-12">Insurance Company</label>
            </div>
            <div class="col-md-10">
              <div class="row">
                <div class="col-md-2 position-relative h-30 mb-4">
                  <select name="showPolicy" id="showPolicy" class="form-select form-select-custom input_" [(ngModel)]="policyType">
                      <option *ngFor="let show of showPolicyList" [value]="show.value">
                          {{show.text}}
                      </option>
                  </select>
                  <label class="float-start label_ms fs-14-br-12">Show Policy</label>
                </div>
                <div class="col-md-2 position-relative h-30 mb-4">
                  <select name="showPolicy" id="showPolicy" class="form-select form-select-custom input_" [(ngModel)]="isMotor" (change)="segmentChange()">
                      <option *ngFor="let seg of segmentList" [value]="seg.value">
                          {{seg.text}}
                      </option>
                  </select>
                  <label class="float-start label_ms fs-14-br-12">Policy Segment</label>
                </div>
                <div class="col-md-2 position-relative h-30 mb-4">
                  <app-multi-dropdown class="w-100 multiselect_custom input_ d-block" [items]="insuranceProductList"
                      [className]="'bg-white'" [showSearch]="true" [showAll]="true" [showStatus]="false" [ddlMenuClassName]="'w-auto'"
                      (itemChange)="onSegmentMultiSelectChange($event)" placeholder=" " id="segmentsFilter">
                  </app-multi-dropdown>
                  <label class="float-start label_ms fs-14-br-12">Policy Category</label>
                </div>
                <div class="col-md-2 position-relative h-30 mb-4" [ngClass]="{'mb-5': policyNumber != '' && policyNumber.length < 6}">
                  <input type="text" [(ngModel)]="policyNumber" class="form-control input_" placeholder=" " minlength="6">
                  <label class="label_">Policy Number</label>
                  <span class="error_span text-danger" *ngIf="policyNumber != '' && policyNumber.length < 6">Min length is 6</span>
                </div>
                <div class="col-md-2 position-relative h-30 mb-4" [ngClass]="{'mb-5': registrationNumber != '' && registrationNumber.length < 6}" *ngIf="showRegistrationNo">
                  <input type="text" [(ngModel)]="registrationNumber" class="form-control input_" placeholder=" " minlength="6">
                  <label class="label_">Reg. No.</label>
                  <span class="error_span text-danger" *ngIf="registrationNumber != '' && registrationNumber.length < 6">Min length is 6</span>
                </div>
                <div class="col">
                  <app-custom-button text="Apply Filter" [width]="'max-content'" className="" [height]="'34px'" leadingIconName="" (onClick)="applyFilter()"></app-custom-button>
                </div>
              </div> 
            </div>
          </div>            
        </div>
        <div class="col-md-3 position-relative h-30 mb-4" *ngIf="userType == '2'">
            <app-multi-dropdown class="w-100 multiselect_custom input_ d-block" [items]="distributorList"
                [className]="'bg-white'" [showSearch]="true" [showAll]="true" [showStatus]="false"
                (itemChange)="onDistributorMultiSelectChange($event)" placeholder=" " id="distributorlist">
            </app-multi-dropdown>
            <label class="float-start label_ms fs-14-br-12">Distributor</label>
        </div>
        <div class="col-md-3 position-relative h-30 mb-4" *ngIf="userType == '2' || userType == '3'">
          <app-multi-dropdown class="w-100 multiselect_custom input_ d-block" [items]="resellerList"
              [className]="'bg-white'" [showSearch]="true" [showAll]="true" [showStatus]="false"
              (itemChange)="onResellerMultiSelectChange($event)" placeholder=" " id="resellerlist">
          </app-multi-dropdown>
          <label class="float-start label_ms fs-14-br-12">Reseller</label>
        </div>
        <div class="col-md-3 position-relative h-30 mb-4">
          <app-multi-dropdown class="w-100 multiselect_custom input_ d-block" [items]="agentList"
              [className]="'bg-white'" [showSearch]="true" [showAll]="true" [showStatus]="false"
              (itemChange)="onAgentMultiSelectChange($event)" placeholder=" " id="agentList">
          </app-multi-dropdown>
          <label class="float-start label_ms fs-14-br-12">Agent</label>
        </div>
        
        <!-- <div class="col-3 position-relative">
          <select name="" placeholder=" " class="form-control input_" [(ngModel)]="selectedSegment" (change)="onSegmentChange()">
            <option value="">All Segments</option>
            <option *ngFor="let item of segmentList" [value]="item.id">{{item.name}}</option>
          </select>
          <label for="" class="label_">Filter sales data by Segment</label>
        </div>   -->
        
        <div class="col-3 position-relative" *ngIf="loyaltyBenifits">
          <select name="" placeholder=" " class="form-control input_" [(ngModel)]="selectedLoyaltyBonus" (change)="onLoyaltyBonusAssignedChange()">
            <option value="">Both</option>
            <option *ngFor="let item of loyaltyBonusAssignedList" [value]="item">{{item}}</option>
          </select>
          <label for="" class="label_">Show Loyalty Bonus Assigned</label>
        </div>  
      </div>
      <div class="box-header mb-4 w-100 pl-2" *ngIf="false">
          <label class="m-0 box_title_22 pl-1"> Sales </label>
      </div>
      <div class="row w-100 position-relative" *ngIf="false">
        <div class="col-4 position-relative">
          <select name="" placeholder=" " class="form-control input_" [(ngModel)]="agentId">
            <option value="9999999">Select Agent</option>
            <option *ngFor="let item of agentListExport" [value]="item.id">{{item.name}}</option>
          </select>
          <label for="" class="label_">Select agent for export</label>
        </div>
        <div class="col-auto tabs_content">
          <app-custom-button text="Export Policies Expiring in next 30 Days" [width]="'max-content'" className="mr-2" [height]="'34px'" leadingIconName="" (onClick)="exportToExcel1()" [disabled]="agentId == 9999999"></app-custom-button>
        </div>    
      </div>
    </div>

    <div class="position-relative">
      <app-table-view
      [visibleColumnData] = "visibleColumnData"
      [visibleColumnsId] = "visibleColumnsId"
      [graphdata]="graphdata"
      [graphHeader]="graphHeader"
      title=""
      tableBackground="var(--grey3)"
      buttonTitle="Import Offline Policy"
      [showIconButtonEnd]="false"
      [showIconButtonStart]="true"
      [showPaginator]="true"  
      (onActionClick)="onActionClick($event)"
      (onCreateBtnClick)="onCreateBtnClick($event)"
      [canCreate]="canCreate"
      [canView]="canView"
      [canDelete]="false"
      [canEdit]="canEdit"
      [canDowanload]="true"
      className="rounded-top1-0"
      [sortedIndex]=sortedIndex
      [sortOrder]=sortOrder
      [loyaltyBenifits]="loyaltyBenifits"
      [loyaltyBenifitsDesc]="loyaltyBenifitsDesc"
      [showLoader]="showLoader"
      [tableId]="'salesList'"
    ></app-table-view>
    </div>

    <div class="overlay" *ngIf="showLoyaltyBenifitsForm">
    <div class="popup2 position-relative col-md-4">
      <div class="modal-header tooltip_ py-1 text-white">
        <h3>Loyalty Bonus</h3>
        <button type="button" class="close pull-right svg_white" aria-label="Close"  (click)="this.showLoyaltyBenifitsForm = false;">
          <span aria-hidden="true"></span>
       </button>
      </div>
      <div class="modal-body min-h-330  px-0 pt-4">       
        <form class="form needs-validation" [formGroup]="loyaltyBenifitsForm" novalidate="">
          <div class="col-12 position-relative">
            <input type="date" placeholder=" " class="form-control input_" formControlName="loyaltyAssignDate" (keypress)="numericOnly($event)" 
            [ngClass]="{'border border-danger': ((loyaltyBenifitsFormControl['loyaltyAssignDate'].touched  || submittedLoyaltyBenifitsForm) && !loyaltyBenifitsFormControl['loyaltyAssignDate'].valid)}">
            <label for="loyaltyAssignDate" class="label_">Assign Date</label>
            <Span class="text-danger error_span" *ngIf="((loyaltyBenifitsFormControl['loyaltyAssignDate'].touched || submittedLoyaltyBenifitsForm) && loyaltyBenifitsFormControl['loyaltyAssignDate'].errors?.['required'])">
                Assign date is required
            </Span> 
          </div>    
          <div class="col-12 position-relative">
            <textarea placeholder=" " class="form-control input_" formControlName="comment" rows="3"></textarea>
            <label for="loyaltyBenifit" class="label_ ta3">Comment</label>
          </div> 
        </form>
        <div class="col-12 position-absolute bottom-15 right-0 d-flex justify-content-around">
          <!-- <app-custom-button text="Remove AuthKey" [width]="'auto'" [height]="'38px'" leadingIconName="" (click)="removeAuthKey()" className="btn_outline border-danger text-danger" *ngIf="isAuthkeyExists"></app-custom-button> -->
          <app-custom-button text="Update Loyalty Bonus" [width]="'auto'" [height]="'38px'" leadingIconName="" (click)="updateLoyaltyBenifits()"></app-custom-button>
        </div>
      </div>
    </div>
  </div>
  <app-stepper-dialog></app-stepper-dialog>
  </app-mainscreen>